import { defineMessages } from 'react-intl';

const messages = defineMessages({
  FulfillmentPlanMoveItemEvent: {
    description: 'FulfillmentPlan activity move item event',
    defaultMessage: '{Quantity} {SKU} moved from {FromFulfillmentPlanId} to {ToFulfillmentPlanId}',
    id: 'fN9dtF',
  },
  GenericUpdate: {
    description: 'FulfillmentPlan activity generic update event',
    defaultMessage: 'Item quantity changed from {previousCount} to {newCount}',
    id: 'JBGBIx',
  },
  LabelCreateEvent: {
    description: 'FulfillmentPlan activity label created event',
    defaultMessage: 'Shipment created: {carrierName} {TrackingNumber}',
    id: 'YkCZoU',
  },
  RestoredFromHold: {
    description: 'FulfillmentPlan activity restored from hold event',
    defaultMessage: 'Order restored from hold',
    id: 'j6do2u',
  },
  SetOnHold: {
    description: 'FulfillmentPlan activity set on hold event',
    defaultMessage: "Order placed 'On Hold' until {holdUntil}",
    id: 'RyNY96',
  },
  loadMore: {
    description: 'FulfillmentPlan activity load all link text',
    defaultMessage: 'Load more',
    id: '2F8SO2',
  },
  system: {
    description: 'FulfillmentPlan activity default username placeholder',
    defaultMessage: 'System',
    id: 'Z+zkTA',
  },
  rowHeader: {
    description: 'FulfillmentPlan activity event row header',
    defaultMessage: '<a>{userDateTime}</a> by: <b>{username}</b>',
    id: '7yK7eo',
  },
});

export default messages;
